<script lang="ts" setup>
import { ref } from 'vue';
import ThemeTopicSelectModal from './theme-topic-select-modal.vue';

const open = ref(false);
</script>

<template>
  <div class="o-add-keyword-button c-btn c-btn--medium" @click="open = true">
    トピックからキーワードを追加
  </div>

  <ThemeTopicSelectModal v-model:open="open" />
</template>

<style lang="scss" scoped>
.o-add-keyword-button {
  width: 234px;
  cursor: pointer;
  color: $color-gray1000;
}
</style>
